document.addEventListener("DOMContentLoaded", function () {

  const container = document.getElementById("categoria-on1p-products");
  if (!container) return;

  const categoryButtons = document.querySelectorAll(".categoria-on .categoria-item");
  if (!categoryButtons.length) return;

  /* =========================
     Helpers
  ========================= */

  function renderLoader() {
    container.innerHTML = `
      <div class="categoria-on1p-loader">
        Cargando productos...
      </div>
    `;
  }

  function renderError() {
    container.innerHTML = `
      <div class="categoria-on1p-loader">
        No pudimos cargar productos.
      </div>
    `;
  }

  function renderProducts(htmlArray) {
    container.innerHTML = `
      <div class="categoria-on1p-grid" id="categoria-on1p-grid">
        ${htmlArray.join("")}
      </div>
    `;

    setTimeout(() => {
      const grid = document.getElementById("categoria-on1p-grid");
      if (grid) grid.classList.add("visible");
    }, 30);
  }

  function fetchCollection(handle) {
    return fetch(`/collections/${handle}?view=ajax`)
      .then(r => r.text());
  }

  /* =========================
     1️⃣ CARGA INICIAL
     Mostrar TODAS las categorías
  ========================= */

  if (!window.__categoriaOnSelected) {

    renderLoader();

    const handles = Array.from(categoryButtons)
      .map(btn => btn.dataset.collection)
      .filter(Boolean);

    Promise.all(handles.map(fetchCollection))
      .then(results => {
        renderProducts(results);
      })
      .catch(() => renderError());
  }

  /* =========================
     2️⃣ CUANDO SE SELECCIONA UNA CATEGORÍA
  ========================= */

  document.addEventListener("categoriaSeleccionada", function (e) {

    const handle = e.detail?.categoria;
    if (!handle) return;

    renderLoader();

    fetchCollection(handle)
      .then(html => {
        renderProducts([html]);
      })
      .catch(() => renderError());
  });

});